import { Language } from '@/enums/language';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

export function useOrdinal(number: number) {
  const { lang: language } = useTranslation();

  const ordinal = useMemo(() => {
    return formatOrdinal(number, language as Language);
  }, [number, language]);

  return ordinal;
}

function formatOrdinal(number: number, locale: Language) {
  const pr = new Intl.PluralRules(locale, { type: 'ordinal' });
  const pluralCategory = pr.select(number);
  const language = locale.split('-')[0];

  switch (language) {
    case Language.English: {
      const suffixes: Record<string, string> = {
        one: 'st',
        two: 'nd',
        few: 'rd',
        other: 'th',
      };
      return `${number}${suffixes[pluralCategory] || 'th'}`;
    }

    case Language.Portuguese:
    case Language.Spanish:
      return `${number}º`;

    case Language.French:
      if (number === 1) {
        return `${number}er`;
      } else {
        return `${number}e`;
      }

    case Language.Dutch:
      return `${number}.`;
    default:
      return number;
  }
}
